import React from 'react';
import { Code2 } from 'lucide-react';

const LanguageSelector = ({ language, setLanguage }) => {
  const languages = ['C++', 'Python', 'Java', 'JavaScript', 'Ruby', 'Go', 'C#'];

  return (
    <div className="mb-6">
      <label htmlFor="language" className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-2">
        <Code2 size={18} className="text-blue-500" />
        Select Programming Language
      </label>
      <select
        id="language"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="w-full rounded-xl border border-gray-300 p-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm transition-all"
      >
        {languages.map((lang) => (
          <option key={lang} value={lang}>
            {lang}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
